<template>
  <div id="app">
    <app-update v-if="isUpdateAvailable" />
    <div class="content-wrap">
      <app-header />
      <main
        :class="{
          'main-homepage': isHomePage,
          'with-sidebar': isSidebar,
          'min-header': isMinHeader,
        }"
      >
        <mobile-sidebar v-if="isSidebar" class="mobile-sidebar" />
        <sidebar-nav v-if="isSidebar" class="sidebar-nav" />
        <router-view class="router-view"></router-view>
        <transition name="slide" mode="out-in">
          <global-message v-if="message" />
        </transition>
      </main>
    </div>
    <app-footer v-if="isFullFooter" />
    <app-footer-minimal v-if="!isFullFooter" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import VueLazyload from 'vue-lazyload'
import AppHeader from './app-header.vue'
import AppFooter from './app-footer.vue'
import AppUpdate from './app-update.vue'
import SidebarNav from './sidebar-nav.vue'
import MobileSidebar from './mobile-sidebar.vue'
import AppFooterMinimal from './app-footer-minimal.vue'
import globalMessage from 'components/common/global-message.vue'
import opportunitiesApi from '../../services/opportunities.service.js'

Vue.use(VueLazyload)

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
    AppUpdate,
    AppFooterMinimal,
    SidebarNav,
    MobileSidebar,
    globalMessage,
  },
  metaInfo: {
    title: 'Africa Corporate Data | Investment in Africa | Africa Companies',
    titleTemplate: '%s | Asoko Insight',
  },
  data() {
    return {
      isUpdateAvailable: false,
    }
  },
  computed: {
    message() {
      return this.$store.state.message.text
    },
    isHomePage() {
      return this.$route.path === '/'
    },
    isMinHeader() {
      return this.$route.meta.minheader
    },
    isFullFooter() {
      return !this.$route.meta.minfooter
    },
    isSidebar() {
      return this.$route.meta.sidebar
    },
  },
  methods: {
    ...mapActions({
      checkAndRefresh: 'checkAndRefresh',
      setFeatureFlags: 'setFeatureFlags',
    }),
    addUpdateListener() {
      window.addEventListener('error', e => {
        if (
          e.message === "Uncaught SyntaxError: Unexpected token '<'" ||
          /Loading chunk [\d]+ failed/.test(e.message)
        ) {
          this.isUpdateAvailable = true
        }
      })
    },
  },
  created() {
    this.checkAndRefresh()
    this.setFeatureFlags()
  },
  mounted() {
    this.$store.dispatch('user/removeLegacyCookie')
    this.$intercom.boot()
    this.addUpdateListener()
    this.$store.dispatch('dealbook/getOpportunities')
  },
}
</script>

<style lang="scss">
@import '../../assets/bootstrap.min.css';
@import '../../assets/fonts/stylesheet.css';
@import '~assets/about-us.css';
@import '~assets/services.css';
html,
body {
  height: 100%;
}
body {
  font-family: $base-font-family;
}
%headings {
  font-family: 'Sarabun', sans-serif;
}
a {
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: $link-hover-color;
  }
  &:active {
    text-decoration: none;
    color: $link-hover-color;
  }
  &:focus {
    text-decoration: none;
    color: $link-hover-color;
  }
}
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.profile-page-app /deep/ {
  @import '~assets/styles/app-legacy.scss';
}
#app /deep/ {
  @import '~theme/styles/_buttons';
}
#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
}
footer {
  flex-shrink: 0;
}
main {
  margin-top: $slim-header-height;
  flex: 1 1 auto;
  @include desktop {
    margin-top: $header-height;
  }
  &.with-sidebar {
    display: flex;
  }
  &.min-header {
    margin-top: $slim-header-height;
  }
  .sidebar-nav {
    display: none;
    @include desktop {
      display: block;
      margin-top: 30px;
    }
  }
  .mobile-sidebar {
    @include desktop {
      display: none;
    }
  }
}
.main-homepage {
  margin-top: unset;
}
.data-bar {
  background-color: #5fa5d9;
  color: #fff;
  padding: 10px 0 11px;
}
.asoko-loading {
  text-align: center;
}
.loader-new {
  text-align: center;
  padding-top: 2rem;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
</style>
